module.exports = __webpack_public_path__ + "img/NW6378-Silk-Top-Hair-System-with-Clear-PU-around-2-300x300.8d3dc45e.jpg";